import { render } from "./ReservationComponent.vue?vue&type=template&id=1d65fdec&scoped=true"
const script = {}

import "./ReservationComponent.vue?vue&type=style&index=0&id=1d65fdec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d65fdec"]])

export default __exports__